// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"25bd1dbb","796":"3d48335e","824":"e073347c","937":"aa72f17a"}[chunkId] + ".chunk.js";
};